import useWindowDimensions from './useWindowDimensions';

export default useWindowDimensions;
